import TasksCalendarScreenContent from "../../features/tasksCalendar/widgets/TasksCalendarScreenContent";

function TasksCalendarScreen() {
  return (
    <section className="clients-page" id="Csection" tabIndex="-1">
      <div className="container">
        <TasksCalendarScreenContent />
      </div>
    </section>
  );
}

export default TasksCalendarScreen;
